import * as React from 'react';
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';

import { cn } from '@/lib/utils';

const ScrollArea = React.forwardRef<
	React.ElementRef<typeof ScrollAreaPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root> & {
		scrollBarClassName?: string;
		scrollThumbClassName?: string;
	}
>(
	(
		{ className, children, scrollBarClassName, scrollThumbClassName, ...props },
		ref,
	) => {
		return (
			<ScrollAreaPrimitive.Root
				ref={ref}
				className={cn('relative overflow-hidden', className)}
				{...props}>
				<ScrollAreaPrimitive.Viewport
					className={cn('h-full w-full rounded-[inherit]')}>
					{children}
				</ScrollAreaPrimitive.Viewport>
				<ScrollBar
					className={scrollBarClassName}
					scrollThumbClassName={scrollThumbClassName}
				/>
				<ScrollAreaPrimitive.Corner />
			</ScrollAreaPrimitive.Root>
		);
	},
);
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;

const ScrollBar = React.forwardRef<
	React.ElementRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>,
	React.ComponentPropsWithoutRef<
		typeof ScrollAreaPrimitive.ScrollAreaScrollbar
	> & {
		scrollThumbClassName?: string;
	}
>(
	(
		{ className, orientation = 'vertical', scrollThumbClassName, ...props },
		ref,
	) => {
		return (
			<ScrollAreaPrimitive.ScrollAreaScrollbar
				ref={ref}
				orientation={orientation}
				className={cn(
					'flex touch-none select-none transition-colors bg-[#3D82FE]',
					orientation === 'vertical' &&
						'h-full w-2.5 border-l border-l-transparent p-[1px]',
					orientation === 'horizontal' &&
						'h-2.5 flex-col border-t border-t-transparent p-[1px]',
					className,
				)}
				{...props}>
				<ScrollAreaPrimitive.ScrollAreaThumb
					data-state='visible'
					className={cn(
						'relative flex-1 rounded-full bg-[#ffffff4c]',
						scrollThumbClassName,
					)}
				/>
			</ScrollAreaPrimitive.ScrollAreaScrollbar>
		);
	},
);
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;

export { ScrollArea, ScrollBar };
